import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PaacsbookingpopupComponent } from '../../paacsbooking/paacsbookingpopup/paacsbookingpopup.component';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import * as _ from 'lodash';
import { DivisionService } from 'src/app/services/division.service';

@Component({
  selector: 'app-selectProduct',
  templateUrl: './selectProduct.component.html',
  styleUrls: ['./selectProduct.component.css']
})
export class SelectProductComponent implements OnInit {

  ImplementList: any;
  filterImplementList: any;
  form: FormGroup;
  totalMachinery: any;
  subsidyAmount: any = 0;
  data: number;
  componentId: any;
  subsidy: any;
  selectedProduct: any;
  indicesToRemove: any[]=[];
  disable: boolean=true;

  constructor(@Inject(MAT_DIALOG_DATA) public dataRecievedData: any,
    public dialogRef: MatDialogRef<SelectProductComponent>,
    private divisionService: DivisionService) { }

  ngOnInit() {
    this.initialValidators()

    this.componentId = this.dataRecievedData.componentId;
    this.selectedProduct=this.dataRecievedData.product;
    this.getProduct()
  }

  spliceProduct()
  {
    for (let i = 0; i < this.filterImplementList.length; i++) {
     this.selectedProduct.forEach(element => {
      if(this.filterImplementList[i].key==element)
      {
        this.indicesToRemove.push(i);
      }
     });
    }
    
    if (this.indicesToRemove.length > 0) {
      // Sort the indices in reverse order to avoid issues when splicing
      this.indicesToRemove.reverse();
    
      // Splice the array to remove the elements at the found indices
      for (const index of this.indicesToRemove) {
        this.filterImplementList.splice(index, 1);
      }
    
    }
    // const index = this.filterImplementList.findIndex(element => element === targetValue);
  }

  getProduct() {
    this.divisionService
      .getProductListSavebyId(this.dataRecievedData.financialyear,this.dataRecievedData.DepartmentId,this.dataRecievedData.goid,this.dataRecievedData.scheme,this.dataRecievedData.componentId,true).subscribe((result) => {
        this.ImplementList = result;
        this.filterImplementList = result;
        this.filterImplementList = _.orderBy(this.filterImplementList, ['value'], ['asc']);
        // if (this.sharedDatalist.dbtProductId > 0) {
        //   this.valuesForm.controls["product"].setValue(this.sharedDatalist.dbtProductId);
        //   this.productChange();
        // }
        if(this.selectedProduct.length>0)
        {
          this.spliceProduct()

        }
      });
  }

  cancel() {

    this.dialogRef.close()
  }
  initialValidators() {
    this.form = new FormGroup({
      product: new FormControl('',Validators.required),
      count:new FormControl('',Validators.required)
    })
  }
  productChange()
  {

  
    this.disable=false;
    this.totalMachinery=0
    this.subsidyAmount = 0;
  }

  onKeyChange(event) {
    if (event.target.value == "" || event.target.value == "0") {
      this.data = 0;
    } else {
      this.data = parseInt(event.target.value);
    }
    this.subsidy = _.find(this.filterImplementList, ['key', (this.form.value.product)])?.subsidyPerUnit;
    this.subsidyAmount = this.data * this.subsidy
    this.totalMachinery = this.data == 0 ? 0 : this.data 
  }

  submit() {
 
if(this.form.valid)
{
    var data = {
      product: _.find(this.filterImplementList, ['key', (this.form.value.product)])?.value,
      count: this.totalMachinery,
      subsidy: this.subsidyAmount,
      subsidyPerunit:this.subsidy,
      selectedProduct:this.form.value.product
    }
    
    
    this.dialogRef.close(data)
  }else
  {
    this.validateFormControl();
  }
  }
  validateFormControl() {
    Object.keys(this.form.controls).forEach((field) => {
      const control = this.form.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({
          onlySelf: true,
        });
      }
    });
  }
}
